import { useMutation } from 'react-query';

import { createDashboard as mutationFn } from 'api/endPoints/createDashboard';

import { IDashboard } from 'components/Dashboards/Project/Components/CustomDashboard/utils/utils.type';

type IpayloadCreateDashboard = {
    name: string;
};
export const useMutationCreateDashboard = () => {
    return useMutation<IDashboard, QueryError, IpayloadCreateDashboard>((params) => mutationFn(params));
};
